import BaseService from './BaseService';

const webApi = '/api/subscription/feed/';

class DataSelectService extends BaseService {
  getTVs(datatype) {
    return this.get(`${webApi}tvlist`, { datatype }).then((res) => res.tvlist);
  }

  getAssetClasses(datatype, tv) {
    return this.get(`${webApi}assetclasslist`, { datatype, tv }).then((res) => res.assetclasslist);
  }

  getSubAssetClasses(datatype, tv, assetclass) {
    return this.get(`${webApi}subassetclasslist`, { datatype, tv, assetclass }).then((res) => res.subassetclasslist);
  }

  getInstruments(datatype, tv, assetclass, subassetclass) {
    return this.get(`${webApi}instrumentlist`, { datatype, tv, assetclass, subassetclass }).then(
      (res) => res.instrumentlist
    );
  }

  getSegmentMics(datatype, tv, assetclass, subassetclass, instrument) {
    return this.get(`${webApi}miclist`, { datatype, tv, assetclass, subassetclass, instrument }).then(
      (res) => res.miclist
    );
  }

  getOrderTypes(datatype, tv, assetclass, subassetclass, instrument, instrumentmic) {
    return this.get(`${webApi}ordertypelist`, { datatype, tv, assetclass, subassetclass, instrument, instrumentmic }).then(
      (res) => res.ordertypelist
    );
  }
}

export default DataSelectService;



// WEBPACK FOOTER //
// ./src/services/DataSelectService.js